// extracted by mini-css-extract-plugin
export default {"wrapper":"Currency_wrapper__dkN2w","icon":"Currency_icon__cVDUX","label":"Currency_label__dLn2B"};